<template>
    <div
        class="[ mk-artwork-show artwork-container ] container-fluid px-0"
        style="min-height: 100%;"
    >


        <!-- Fade in on load JS overlay -->
        <div class="animejs-fade-wrap artshow-fade-in-overlay">
            <img
                class="animejs-fade-logo img-fluid"
                style="opacity: 0; margin-top: 5px; max-height: 61px;"
                src="/images/branding/logo-artsight-branding.png"
            />
        </div>


        <div
            class="[ art-perspective-bg ]"
            :style="backgroundPageStyle"
        >
        </div>

        <div class="container" style="padding-top: 40px; min-height: calc(100vh - var(--fe-footer-height))">
            <div class="row px-3">
                <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-4 mx-auto px-0 d-flex flex-column">
                    <div v-if="!artwork.is_perspective_enabled">
                        <p class="mb-1" :style="showPerspective ? 'opacity: 1;' : 'opacity: 0;'">Perspectives on</p>
                    </div>
                    <h1 v-if="artwork.name" class="mb-3 font-secondary" style="font-size: 24px; position: relative;">
                        <artwork-save :hide_bookmark="showPerspective ? false : true" :artwork="artwork" style="position: absolute; right: 15px; top: 6px;"></artwork-save>
                        {{ artwork.name }}
                    </h1>
                    <h2 v-if="artwork.artist" class="font-secondary fw-400">{{ artwork.artist.name }}</h2>
                </div>
            </div>


            <div v-if="showShare" class="px-3">
                <artwork-share-perspective :artwork="artwork"></artwork-share-perspective>
            </div>

            <div v-if="showPerspective" class="px-3">
                <div v-if="!artwork.is_perspective_enabled">
                  <artwork-perspective :artwork="artwork"></artwork-perspective>
                </div>
                <div v-else>
                  <div class="mk-artwork-perspective row">
                    <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-4 mx-auto px-0 ">
                      <artwork-perspective-content :artwork="artwork"></artwork-perspective-content>
                    </div>
                  </div>
                </div>
            </div>

        </div>


        <!-- Show the footer only once they've entered a perspective -->
        <div v-if="showPerspective">
            <div id="divScrollTop" @click="scrollToTop" class="scrollDiv">
                <button>
                    <img
                        class="img-fluid"
                        src="/images/btn-up.png"
                    />
                </button>
            </div>
        </div>
        <FrontendFooter/>
    </div>
</template>


<style>
.artshow-fade-in-overlay {
    z-index: 2;
    opacity: 1;
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: rgba(0, 0, 0, 1);
}

.art-perspective-bg {
    filter: opacity(20%);
    position: fixed;
    top: 0;
    left: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: local;
    height: 100vh;
    width: 100vw;
}

.artwork-container {
    /* min-height: calc(100vh - var(--fe-footer-height)); */
}
</style>


<script>
import FrontendFooter from '../../../frontend/components/FrontendFooter.vue';
import Artwork from "../../models/Artwork";
import anime from 'animejs/lib/anime.es.js';
import axios from "axios";

export default {
    components: { FrontendFooter },
    props: {
        artwork: {
            type: Object,
        },
        hasanswer: {
            type: Number,
        },
        hide_bookmark: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    computed:{
        backgroundPageStyle() {
            if(this.artwork.image_url){
                return `backgroundImage: url(${this.artwork.image_url})`;
            } else {
                return `background-color: #000;`;
            }
        }
    },
    mounted() {
        if(this.artwork && !this.artwork.is_comment_enabled) {
            this.showShare = false;
            this.showPerspective = true;
        }

        if(this.showShare == true && this.artwork.exhibition.gallery.is_enabled_geolocation) {
            this.getUserLocation();
        }

        // Set the footer.
        if(!this.showPerspective) { 
            this.hideFooter(); 
        } else {
            this.showFooter();
        }
            // Straight Black for 100ms
            // Then Fade in logo 500ms
            // Then fade out logo and black rest of duration

        // AnimeJS fade in animation
        var tl = anime.timeline({
            easing: 'linear',
            duration: 2250, //2000
        });
        tl.add({
            targets: '.animejs-fade-wrap',
            background: 'rgba(0, 0, 0, 0)',
            opacity: 0,
            delay: 500,
        })
        .add({
            targets: '.animejs-fade-logo',
            opacity: 1,
            delay: 0,
            duration: 250,
        }, '-=2525')
        .add({
            targets: ['.animejs-fade-wrap', '.animejs-fade-logo'],
            zIndex: 0,
            opacity: 0,
            display: 'none',
        });
    },
    data() {
        return {
            showShare: (this.hasanswer == 0) ? true : false,
            showPerspective:  (this.hasanswer == 1) ? true : false,
        };
    },
    methods: {
        async getUserLocation() {
            var self = this;
            if(navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function(position) {
                    let lat = position.coords.latitude;
                    let lon = position.coords.longitude;

                    self.processLocation(lat, lon);
                }, function(error) {
                    self.processLocation('', '');
                });
            } else {
                self.processLocation('', '');
            }

        },

        async processLocation(lat, lon) {
            await axios
                .get('/api/v1/frontend/artwork_location/'+this.artwork.id+'?lat='+lat+'&lon='+lon)
                .then((response) => {
                    if(response && response.data == 1) {
                        this.showShare          = true;
                        this.showPerspective    = false;
                    } else {
                        this.showShare          = false;
                        this.showPerspective    = true;
                    }
                    this.showFooter();
                })
                .catch(function (e) {
                    console.log(e);
                });
        },
        scrollToTop() {
            $('html, body').animate({scrollTop:0}, 'slow');
        },
        hideFooter: function(){
            const footer = document.querySelector("#app > main > div > div > div > footer");
            footer.style.display = "none";
        },
        showFooter: function(){
            const footer = document.querySelector("#app > main > div > div > div > footer");
            footer.style.display = "block";
        }
    }
};
</script>
